<template lang="pug">
  main#main.organization-profile
    b-container(fluid)
      wc-breadcrumb(icon='fal fa-building')
      section.l-section
        .l-section-h
          b-row.mb-5
            b-col
              router-view
</template>

<script>
import WcBreadcrumb from '@components/shared/WcBreadcrumb'

export default {
  name: 'organization-profile',
  components: {
    WcBreadcrumb,
  },
}
</script>
